const GRAVITY_WEBSITE_HANDOFF_CAPTURE_GRACE_MS = 30_000;

const shouldClearGravityWebsiteHandoff = ({ result, savedAt, now = Date.now() } = {}) => {
  if (result?.success === true || result?.code === 'GRAVITY_WEBSITE_HANDOFF_INVALID') {
    return true;
  }

  return result?.code === 'GRAVITY_WEBSITE_HANDOFF_EXPIRED' && now - savedAt >= GRAVITY_WEBSITE_HANDOFF_CAPTURE_GRACE_MS;
};

export default shouldClearGravityWebsiteHandoff;
